<template>
    <input v-model="localeValueHolder" @input="inputHandler()" autocomplete="off" :name="indicator" :id="indicator" type="text" class="primary-input extra-light-text" :placeholder="placeholder"/>
</template>
<script>
export default {
    data(){
        return {
            inputTimeStamp: null,
            localeValueHolder: null,
        }
    },
    props: {
        Vmodel: {
            type: String,
            default: "",
        },
        indicator: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "ძებნა",
        },
    },
    watch: {
        Vmodel: {
            handler(newVal){
                this.localeValueHolder = newVal;
            },
            immediate: true,
            // once: true,
        },
    },
    methods: {
        inputHandler(){
            this.inputTimeStamp = new Date().getTime();
            setTimeout(() => {
                if(this.inputTimeStamp && new Date().getTime() - this.inputTimeStamp >= 600){
                    this.emitValue();
                }
            }, 600);
        },
        emitValue(){
            this.$emit('valueUpdated', this.localeValueHolder);
        },
    }
}
</script>